import {
  ApiGetRequest,
  ApiBlobGetRequest,
  ApiPostRequest,
  // ApiPostRequest,
  // ApiDeleteRequest,
  // ApiPutRequest,
} from '../../../api';
import moment from 'moment-mini';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Report - Seal',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/report',
      },
      {
        text: 'Report - Seal',
        href: '/adm/opr/report/seal',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_seal',
    sortDesc: true,
    export: 0,
    fields: [
      {
        key: 'code_seal',
        label: 'Kode',
      },
      {
        key: 'tgl_input',
        label: 'Masuk',
      },
      {
        key: 'tgl_pakai',
        label: 'Keluar',
      },
      {
        key: 'seal_number',
        label: 'Seal',
      },
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'shipper',
        label: 'Shipper',
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'type',
        label: 'Type',
      },
      {
        key: 'doc_no',
        label: 'Booking',
      },
      {
        key: 'vessel',
        label: 'Vessel',
      },
      {
        key: 'voy',
        label: 'Voy',
      },
      {
        key: 'pengguna',
        label: 'Remark',
      },
    ],
    detail: false,
    form: {
      id_user: '',
      name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  reportSeal(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getReportSeal({ commit, state }) {
    commit('reportSeal', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: '',
      start_date:
        data.form.date && data.form.date.length > 0 && data.form.date[0]
          ? moment(data.form.date[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form.date && data.form.date.length > 0 && data.form.date[1]
          ? moment(data.form.date[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/report/seal`, params);
    commit('reportSeal', {
      items: result.data.object || [],
      total: result.data.total || 0,
      loading: false,
    });

    return result.error ? false : true;
  },

  async getExportReportSeal({ commit, state }) {
    commit('reportSeal', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: '',
      start_date:
        data.form.date && data.form.date.length > 0 && data.form.date[0]
          ? moment(data.form.date[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form.date && data.form.date.length > 0 && data.form.date[1]
          ? moment(data.form.date[1]).format('YYYY-MM-DD')
          : '',
      export: 1,
    };

    let result = await ApiBlobGetRequest(`opr/report/seal`, params);
    commit('reportSeal', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_seal.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },

  async resendEmailSeal({ commit, dispatch }, payload = null) {
    commit('reportSeal', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/report/seal-resend`, payload);
    commit('reportSeal', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async downloadDataExcel({ commit }, payload = null) {
    commit('reportSeal', {
      loading: true,
    });

    let result = await ApiBlobGetRequest(
      `opr/report/seal-download/${payload.id}`
    );
    commit('reportSeal', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_seal.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },
};
